import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/quickValet";

export default class QuickValetService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getZones = () => {
		return http.get(`${apiEndpoint}/adminZone`);
	};

	pay = (id, data) => {
		return http.post(`${apiEndpoint}/payLeaveParking/${id}`, data);
	};
}
